import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="pt-40 min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <XCircle className="w-16 h-16 text-mj-muted mx-auto mb-6" strokeWidth={1.2} />
        <h1 className="font-serif-mj text-5xl tracking-tight text-mj-text">Payment cancelled</h1>
        <p className="font-sans-mj text-mj-muted mt-5 leading-relaxed">No worries — your selection is still saved. You can complete your order whenever you're ready.</p>
        <Link to="/checkout" className="inline-block mt-10 bg-mj-red text-mj-bg px-8 py-4 overline hover:bg-mj-reddark transition-colors">Return to Checkout</Link>
      </div>
    </div>
  );
}
